import { makeStyles } from '@material-ui/core/styles'
import AccordionBase from '../../../2compounds/AccordionBase'
import React, { useState } from 'react'
import useMultipleColumnsDataList from './useMultipleColumnsDataList'
import { Reorder } from 'framer-motion'
import { useParams } from 'react-router-dom'

const MultipleColumnsDataList = ({
  admin,
  index,
  editMode,
  data,
  resetToDefault,
  reorderFields,
  toggleIsHidden,
  updateFieldLabel,
  updateCardLabel,
  isCardDirty,
  updateCardLabelMultipleColumns,
  updateDataType,
  layoutDefaultData
}) => {
  const { label, cardData } = data
  const [isOpen, setIsOpen] = useState(true)
  const { viewSwitcher } = useMultipleColumnsDataList()
  const labelArray = JSON.parse(label)
  const numberOfColumn = labelArray.length
  const { tabName } = useParams()
  const classes = useStyles({ admin, numberOfColumn, tabName })

  return (
    <AccordionBase
      label={label}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className={classes.root}
      admin={admin}
      updateCardLabel={updateCardLabel}
      resetToDefault={resetToDefault}
      isCardDirty={isCardDirty}
      hideShowHIdeButton
      data={data}
      index={index}
      multipleColumns
      updateCardLabelMultipleColumns={updateCardLabelMultipleColumns}
      layoutDefaultData={layoutDefaultData}
    >
      <Reorder.Group
        axis='y'
        values={cardData}
        onReorder={newValue => reorderFields(newValue, index)}
        className={classes.reorderGroupDiv}
        layoutScroll
      >
        {cardData &&
          cardData.map((item, fieldIndex) =>
            viewSwitcher(
              admin,
              editMode,
              item,
              index,
              fieldIndex,
              updateFieldLabel,
              numberOfColumn,
              toggleIsHidden,
              labelArray,
              updateDataType
            )
          )}
      </Reorder.Group>
    </AccordionBase>
  )
}

export default React.memo(MultipleColumnsDataList)

const useStyles = makeStyles(theme => ({
  root: {
    height: '95%',
    gridColumn: 'span 8',
    margin: '0px 10px 0 !important',
    gridRow: props => (props.tabName === 'tab2' ? 'span 4' : 'span 3'),
    display: 'flex',
    flexDirection: 'column',
    border: props =>
      props.admin ? `1px dashed ${theme.palette.tertiary.main}` : 'none',
    paddingRight: 2
  },
  cardInnerDiv: {
    margin: '0 10px 0 10px',
    width: '100%',

    '&>div': {
      display: 'grid',
      gridTemplateColumns: props => `repeat(${props.numberOfColumn}, 1fr)`
    }
  },
  header: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    width: '100%'
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main
  },
  row: {
    '&:hover': {
      cursor: 'pointer',
      '& *': {
        color: `${theme.palette.primary.accent} !important`
      }
    }
  },
  reorderGroupDiv: {
    width: '100%',
    marginLeft: 2,
    maxHeight: props =>
      props.tabName === 'tab2'
        ? 'calc((88vh - 317px) / 3)'
        : 'calc((88vh - 375px) / 4)',
    overflowY: 'auto',
    padding: '0px 30px'
  }
}))
